import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=570d1961&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d1961",
  null
  
)

export default component.exports